export * from "./ui-router-rx";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/node_modules/@uirouter/rx/lib-esm/index.js
// module id = ../../../../@uirouter/rx/lib-esm/index.js
// module chunks = vendor